import React, { useState } from 'react';
import { PortfolioStatus } from '../../models/Portfolio';
import { Box, ITheme, IconButton, Link, SvgIcon, Typography, useTheme } from '@mui/material';
import {ReactComponent as stockIcon} from '../../assets/stock.svg'
import {ReactComponent as clockIcon} from '../../assets/clock.svg'
import {ReactComponent as draftIcon} from '../../assets/draft.svg'
import {ReactComponent as checkedIcon} from '../../assets/checked.svg'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import { Utilities } from '../../utility/utils';
import { AUTHENTICATED_ROUTES } from '../../resources/routes-constants';
import { useNavigate } from 'react-router-dom';
import ConfirmationForm from '../common/ConfirmationForm';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../store/reducers/store';
import { deletePortfolio } from '../../store/actions/portfolioLibrary';

export interface IPortfolioItemHeaderProps {
    id: string;
    title: string;
    state: PortfolioStatus;
    closingDate: Date;
    isAddToExisting?: boolean;
}
const PortfolioItemHeader: React.FC<IPortfolioItemHeaderProps> = ({id, title, state, closingDate, isAddToExisting}) => {
    const theme = useTheme() as ITheme;
    const navigate = useNavigate();
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

    if (state === PortfolioStatus.Live){
        return <Box display={"flex"} justifyContent={"space-between"} >
            <SvgIcon component={stockIcon} inheritViewBox sx={{ width: "17px", height: "17px", color: theme.palette.primary.dark}}/>
            <Box bgcolor={theme.palette.primary.dark} borderRadius={"4px"} padding={"4px 2px"}>
                <Typography fontSize={"12px"} lineHeight={"12px"} fontWeight={"500"} color={theme.palette.common.white} padding={"2px 5px"}>Closing in {Utilities.toCountdownDate(closingDate)} days</Typography>    
            </Box>
        </Box>;
    }
    if (state === PortfolioStatus.Pending){
        const onTrackClick = (e: React.MouseEvent<HTMLAnchorElement>) =>{
            e.preventDefault();
            navigate(AUTHENTICATED_ROUTES.PORTFOLIO_TRACKING_ROUTE.replace(":id", `${id}`));
        }
        return <Box display={"flex"} justifyContent={"space-between"} >
            <SvgIcon component={clockIcon} inheritViewBox sx={{ width: "17px", height: "17px", color: theme.palette.primary.dark}}/>
            <Box display={"flex"} gap={"10px"} alignItems={"center"}>
                <Box bgcolor={theme.palette.primary.dark} borderRadius={"4px"} padding={"4px 2px"}>
                    <Typography fontSize={"12px"} lineHeight={"12px"} fontWeight={"500"} color={theme.palette.common.white} padding={"2px 5px"}>{t('PortfolioPageItemStatusPending')}</Typography>    
                </Box>
                <Link href="#" color={theme.palette.primary.dark} onClick={onTrackClick}>Track</Link>
            </Box>
        </Box>;
    }
    if (state === PortfolioStatus.Draft){
        const onEditClick = () =>{
            const route = AUTHENTICATED_ROUTES.PORTFOLIO_EDIT_ROUTE.replace(":id", `${id}`);
            navigate(route);
        }
        const onDeleteClick = (e: React.MouseEvent) => {
            e.stopPropagation();
            setShowDeleteConfirm(true);
        }
        const onDeleteCancel = (e: React.MouseEvent) => {
            e.stopPropagation();
            setShowDeleteConfirm(false);
        }
        const onDelete = (e: React.MouseEvent) => {
            e.stopPropagation();
            dispatch(deletePortfolio(id as string));
        }
        return <Box display={"flex"} justifyContent={"space-between"} >
            <SvgIcon component={draftIcon} inheritViewBox sx={{ width: "17px", height: "17px", color: theme.palette.primary.dark}}/>
            {!isAddToExisting && <Box display={"flex"} gap={"10px"} alignItems={"center"}>
                <IconButton onClick={onEditClick} size='small' sx={{ padding: 0}}>
                    <EditIcon fontSize='inherit' sx={{ color: theme.palette.primary.dark }} />
                </IconButton>
                <IconButton onClick={onDeleteClick} size={'small'} sx={{ padding: 0}}>
                    <DeleteOutlineIcon fontSize='inherit' sx={{ color: theme.palette.primary.dark }} />
                </IconButton>
            </Box>}
            {showDeleteConfirm && <ConfirmationForm title={t('PortfolioPageDeleteTitle')} content={`${t('PortfolioPageDeleteContent1')}${title}${t('PortfolioPageDeleteContent2')}`} onClose={onDeleteCancel} 
                confirmAction={[{type: 'primary', title: t('PortfolioPageDeleteButtonDelete'), action: onDelete}, {type: 'secondary', title: t('PortfolioPageDeleteButtonCancel'), action: onDeleteCancel}]}/>}
        </Box>;
    }
    if (state === PortfolioStatus.Closed){
        return <Box display={"flex"} justifyContent={"space-between"} >
            <SvgIcon component={checkedIcon} inheritViewBox sx={{ width: "17px", height: "17px", color: theme.palette.primary.dark}}/>
        </Box>;
    }
    return <></>
}

export default PortfolioItemHeader;